import {useCallback, useContext, useEffect, useState} from 'react';
import {TextFormatCasingBase} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/actions/TextFormat/components/Casing/TextFormatCasingBase/TextFormatCasingBase';
import {EventCreateContext} from '~/common/FabricInvitation/EventCreateDesign/EventCreateContext';

const toTitleCase = (text) =>
  text
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');

const toUpperCase = (text) => text.toUpperCase();
const toLowerCase = (text) => text.toLowerCase();

const actions = {
  capitalize: 'capitalize',
  upper: 'upper',
  lower: 'lower',
};

const letterCasingMapping = {
  [actions.capitalize]: toTitleCase,
  [actions.upper]: toUpperCase,
  [actions.lower]: toLowerCase,
};

export const Casing = ({className}) => {
  const {canvas} = useContext(EventCreateContext);
  const activeObjects = canvas?.getActiveObjects();

  const [currentLetterCase, setCurrentLetterCase] = useState(null);

  // biome-ignore lint/correctness/useExhaustiveDependencies: deps
  useEffect(() => {
    const updateLetterCase = () =>
      setCurrentLetterCase(canvas?.getActiveObjects()?.[0]?.letterCasing);

    updateLetterCase();
    canvas?.on('object:reset', updateLetterCase);

    return () => {
      canvas?.off('object:reset', updateLetterCase);
    };
  }, [canvas, activeObjects]);

  const onClickHandler = useCallback(
    (operation) => {
      activeObjects?.forEach((obj) => {
        if (operation) {
          obj.text = letterCasingMapping[operation](obj.text);
        } else {
          obj.text = obj._originalText;
        }

        obj.letterCasing = operation;

        setCurrentLetterCase(operation);
      });

      canvas.requestRenderAll();
      canvas.fire('object:modified');
    },
    [canvas, activeObjects]
  );

  return (
    <div className={className}>
      <TextFormatCasingBase
        value={actions.upper}
        onClick={onClickHandler}
        active={currentLetterCase === actions.upper}
        dataQaId="step1-textformat-uppercase"
        label="AA"
      />
      <TextFormatCasingBase
        value={actions.lower}
        onClick={onClickHandler}
        active={currentLetterCase === actions.lower}
        dataQaId="step1-textformat-lowercase"
        label="aa"
      />
      <TextFormatCasingBase
        value={actions.capitalize}
        onClick={onClickHandler}
        active={currentLetterCase === actions.capitalize}
        dataQaId="step1-textformat-titlecase"
        label="Aa"
      />
    </div>
  );
};
